import React from 'react';

import AdaptiveImage from '@/components/Elements/AdaptiveImage/AdaptiveImage';
import { ImageZoom } from '@/components/Elements/ImageZoom/ImageZoom';

import { PortfolioParagraphContentProps } from '@/helpers/getParagraphForDynamicPage';

import { IImage } from '@/types/types';

import './ImageParagraph.scss';

interface ImageProps extends PortfolioParagraphContentProps {
  image: IImage;
  title: string;
  resizable?: boolean;
}

export const ImageParagraph = ({ image, title, resizable = false }: ImageProps) => (
  <div className="ImageParagraph_wrapper">
    {resizable ? (
      <ImageZoom image={image} alt={title || image.alternativeText} />
    ) : (
      <AdaptiveImage image={image} objectFit="cover" objectPosition="50% 50%" alt={title || image.alternativeText} />
    )}
    {title && <p className="subtitle-3">{title}</p>}
  </div>
);
